import React, { useEffect, useState } from 'react';
import Layout from '../../common/Layout';
import { dispatchMmvData } from '../../store/actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import {
  GetDataWithToken,
  PostDataWithToken,
} from '../../constants/ApiHelper';
import { toast } from 'react-toastify';

const ExportInsurerMaster = () => {
  const mmvData = useSelector((state) => state?.root?.mmvData);

  const dispatch = useDispatch();

  const [insurerData, setInsurerData] = useState([]);
  const [vehicleType, setVehicleType] = useState('');
  const [insurer, setInsurer] = useState('');
  const [uploadType, setUploadType] = useState('');
  const [mappingName, setMappingName] = useState('');
  const [loading, setLoading] = useState(false);

  const loadInsurers = async () => {
    try {
      const res = await GetDataWithToken(
        '/insurers/getAllInsurer'
      );

      if (res?.success) {
        setInsurerData(res?.data || []);
      } else {
        setInsurerData([]);

        toast.error(
          res?.message || 'Unable to load insurers'
        );
      }
    } catch (error) {
      console.error('Load Insurers Error:', error);

      setInsurerData([]);

      toast.error('Failed to load insurers');
    }
  };

  const handleVehicle = (value) => {
    setVehicleType(value);

    dispatchMmvData('vehicleType', value);

    setInsurer('');
    setMappingName('');

    dispatchMmvData('insurerName', '');
    dispatchMmvData('mappingName', '');
  };

  useEffect(() => {
    if (mmvData?.apiUrl) {
      loadInsurers();
    }
  }, [mmvData?.apiUrl]);

  const handleMasterType = (e) => {
    const value = e.target.value;

    setUploadType(value);

    dispatchMmvData('masterType', value);
  };

  const handleSelectInsurer = (value) => {
    setInsurer(value);

    const selectedInsurer = insurerData.find(
      (item) =>
        String(item?.insurerId) === String(value)
    );

    const insurerName =
      selectedInsurer?.insurerName || '';

    const selectedMappingName =
      selectedInsurer?.mappingName || '';

    setMappingName(selectedMappingName);

    dispatchMmvData(
      'insurerName',
      insurerName
    );

    dispatchMmvData(
      'mappingName',
      selectedMappingName
    );
  };
  const downloadFile = (downloadUrl) => {
    try {
      if (!downloadUrl) {
        toast.error('Download URL not found');
        return;
      }
      const link = document.createElement('a');

      link.href = downloadUrl;

      // Hidden anchor
      link.style.display = 'none';

      // Open signed S3 URL
      link.target = '_blank';

      link.rel = 'noopener noreferrer';

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);

      toast.success(
        'Download started successfully!'
      );
    } catch (error) {
      console.error(
        'Download Error:',
        error
      );

      toast.error(
        'Unable to start file download'
      );
    }
  };

  const handleExport = async () => {
    if (!insurer) {
      toast.error('Please select Insurer');
      return;
    }

    if (!uploadType) {
      toast.error('Please select Master Type');
      return;
    }

    if (!mappingName) {
      toast.error(
        'Insurer mapping name not found'
      );
      return;
    }

    const payload = {
      insurer: mappingName,

      masterType: uploadType,

      search: '',
      ...(vehicleType && {
        vehicleType: vehicleType,

        filters: {
          insFastVehicleType: vehicleType,
        },
      }),
    };

    console.log(
      'Export Insurer Master Payload:',
      payload
    );

    try {
      setLoading(true);
      const response = await PostDataWithToken(
        'export-master/export-insurer-master',
        payload
      );

      console.log(
        'Export Insurer Master Response:',
        response
      );

      if (response?.status) {
        toast.success(
          response?.message ||
          'Exported successfully!'
        );
        const downloadUrl =
          response?.data?.downloadUrl;

        const fileName =
          response?.data?.fileName ||
          'export-insurer-master.xlsx';

        console.log(
          'File Name:',
          fileName
        );

        console.log(
          'S3 Download URL:',
          downloadUrl
        );

        if (downloadUrl) {
          downloadFile(downloadUrl);
        } else {
          toast.error(
            'Export completed but download URL was not received'
          );
        }
        setVehicleType('');
        setUploadType('');
        setInsurer('');
        setMappingName('');
        dispatchMmvData(
          'vehicleType',
          ''
        );

        dispatchMmvData(
          'masterType',
          ''
        );

        dispatchMmvData(
          'insurerName',
          ''
        );

        dispatchMmvData(
          'mappingName',
          ''
        );
      } else {
        toast.error(
          response?.message ||
          'Export failed. Please try again.'
        );
      }
    } catch (error) {
      console.error(
        'Export Insurer Master Error:',
        error
      );

      toast.error(
        error?.response?.data?.message ||
        error?.message ||
        'Export failed. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };


  return (
    <Layout>
      <div className="mt-7 mx-4">

        <div className="card mb-4">

          {/* HEADER */}
          <div className="card-header text-white">
            <h5 className="mb-0">
              Export Insurer Master Data
            </h5>
          </div>

          {/* BODY */}
          <div className="card-body">

            <div className="row">
              <div className="col-md-4">

                <label className="form-label">
                  Vehicle Type
                </label>

                <select
                  className="form-control"
                  value={vehicleType}
                  onChange={(e) =>
                    handleVehicle(
                      e.target.value
                    )
                  }
                  disabled={loading}
                >
                  <option value="">
                    All Vehicle / Select Vehicle
                  </option>

                  <option value="2w">
                    Two Wheeler
                  </option>

                  <option value="4w">
                    Private Car
                  </option>

                  <option value="pcv">
                    Passenger Carrying Vehicle
                  </option>

                  <option value="gcv">
                    Goods Carrying Vehicle
                  </option>

                  <option value="misc">
                    Miscellaneous Vehicle
                  </option>
                </select>

              </div>

              <div className="col-md-4">

                <label className="form-label">
                  Insurer{' '}
                  <span className="text-danger">
                    *
                  </span>
                </label>

                <select
                  className="form-control"
                  value={insurer}
                  onChange={(e) =>
                    handleSelectInsurer(
                      e.target.value
                    )
                  }
                  disabled={loading}
                >
                  <option value="">
                    Select Insurer
                  </option>

                  {insurerData?.map(
                    (item, index) => (
                      <option
                        key={
                          item?.insurerId ||
                          index
                        }
                        value={
                          item?.insurerId
                        }
                      >
                        {item?.mappingName}
                      </option>
                    )
                  )}
                </select>

              </div>

              <div className="col-md-4">

                <label className="form-label">
                  Master Type{' '}
                  <span className="text-danger">
                    *
                  </span>
                </label>

                <select
                  className="form-control"
                  value={uploadType}
                  onChange={
                    handleMasterType
                  }
                  disabled={loading}
                >
                  <option value="">
                    Select Master Type
                  </option>

                  <option value="mmv">
                    MMV
                  </option>

                  <option value="rto">
                    RTO
                  </option>

                  <option value="pincode">
                    Pincode
                  </option>

                  <option value="relation">
                    Relation
                  </option>

                  <option value="prevInsurer">
                    Prev Insurer
                  </option>

                  <option value="financier">
                    Financier
                  </option>

                  <option value="occupation">
                    Occupation
                  </option>

                  <option value="exshowroom">
                    Ex Showroom
                  </option>
                </select>

              </div>
              <div className="col-md-3 mt-4">

                <button
                  type="button"
                  className="btn btn-sec w-100"
                  onClick={handleExport}
                  disabled={
                    loading ||
                    !uploadType ||
                    !insurer
                  }
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />

                      Exporting...
                    </>
                  ) : (
                    <>
                      📥 Export & Download
                    </>
                  )}
                </button>

              </div>

            </div>

          </div>

        </div>

        {loading && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor:
                'rgba(0, 0, 0, 0.55)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 99999,
            }}
          >

            <div className="text-center text-white">

              <div
                className="spinner-border text-light"
                style={{
                  width: '3rem',
                  height: '3rem',
                }}
                role="status"
              >
                <span className="visually-hidden">
                  Loading...
                </span>
              </div>

              <h5 className="mt-3">
                Exporting Insurer Master Data...
              </h5>

              <p className="text-white-50 mb-0">
                Please wait, your file is being
                prepared...
              </p>

            </div>

          </div>
        )}

      </div>
    </Layout>
  );
};

export default ExportInsurerMaster;